import React from 'react';
import Ads from '../atoms/Ads';
import { Link } from 'react-router-dom';
import Message from '../organisms/Message';

const MessageView: React.FC = () => {
  return (
    <div id='page' className='lower-page'>
      <header className='l-header p-header'>
        <h1 className='p-header__logo'>
          <Link to='/'>
            <img src='/img/common/logo.png' alt='SKALE' />
          </Link>
        </h1>
      </header>

      <div id='contents'>
        <div className='c-container -narrow'>
          <Message />
        </div>
      </div>

      <footer className='l-footer p-footer'>
        <Ads />
      </footer>
    </div>
  );
};

export default MessageView;
